// extracted by mini-css-extract-plugin
var _1 = "webpack-containers-DemoAlert-DemoAlert-module__container";
var _2 = "webpack-containers-DemoAlert-DemoAlert-module__icon";
var _3 = "webpack-containers-DemoAlert-DemoAlert-module__link";
export { _1 as "container", _2 as "icon", _3 as "link" }
